/**
 * Returns the fudis heading size corresponding to the given headingLevel.
 * "xxs" size is not used due to its small size, so xs is used for heading levels 6 and above.
 *
 * @format
 */

export function getFudisHeadingSize(headingLevel: number) {
    switch (headingLevel) {
        case 1:
            return 'xxl';
        case 2:
            return 'xl';
        case 3:
            return 'lg';
        case 4:
            return 'md';
        case 5:
            return 'sm';
        default:
            return 'xs';
    }
}
